import { DocumentNode } from 'graphql/language';
import gql from 'graphql-tag';

export const ASSIGN_SERVICE: DocumentNode = gql`
  mutation AssignService($substituteID: UUID!, $serviceID: UUID!) {
    assignService(substituteID: $substituteID, serviceID: $serviceID)
  }
`;

export const DELETE_SERVICE_ASSIGNEMENT: DocumentNode = gql`
  mutation DeleteServiceAssignment($serviceID: UUID!) {
    revokeAssignment(serviceID: $serviceID)
  }
`;

export const CONCLUDE_SERVICE: DocumentNode = gql`
  mutation ConcludeService($serviceID: UUID!) {
    concludeService(serviceID: $serviceID)
  }
`;

export const CREATE_SERVICE_AREA: DocumentNode = gql`
  mutation CreateServiceArea($name: String!, $state: String!, $validFrom: Date!, $validTo: Date!) {
    createServiceArea(name: $name, state: $state, validFrom: $validFrom, validTo: $validTo)
  }
`;

export const UPDATE_SERVICE_AREA: DocumentNode = gql`
  mutation UpdateServiceArea($id: UUID!, $name: String, $state: String, $validFrom: Date, $validTo: Date) {
    updateServiceArea(id: $id, name: $name, state: $state, validFrom: $validFrom, validTo: $validTo)
  }
`;

export const DELETE_SERVICE_AREA: DocumentNode = gql`
  mutation DeleteServiceArea($id: UUID!) {
    deleteServiceArea(id: $id)
  }
`;

export const CREATE_SERVICE_AREA_MOBILE: DocumentNode = gql`
  mutation CreateServiceAreaMobile(
    $id: UUID!
    $name: String!
    $shorthandName: String!
    $coordinates: String!
    $comment: String
    $confidentialComment: String
    $legacyID: Int
  ) {
    createServiceAreaMobile(
      id: $id
      name: $name
      shorthandName: $shorthandName
      coordinates: $coordinates
      comment: $comment
      confidentialComment: $confidentialComment
      legacyID: $legacyID
    )
  }
`;

export const UPDATE_SERVICE_AREA_MOBILE: DocumentNode = gql`
  mutation UpdateServiceAreaMobile(
    $id: UUID!
    $name: String
    $shorthandName: String
    $coordinates: String
    $comment: String
    $confidentialComment: String
    $legacyID: Int
  ) {
    updateServiceAreaMobile(
      id: $id
      name: $name
      shorthandName: $shorthandName
      coordinates: $coordinates
      comment: $comment
      confidentialComment: $confidentialComment
      legacyID: $legacyID
    )
  }
`;

export const DELETE_SERVICE_AREA_MOBILE: DocumentNode = gql`
  mutation DeleteServiceAreaMobile($id: UUID!) {
    deleteServiceAreaMobile(id: $id)
  }
`;

export const CREATE_SERVICE_AREA_OFFICE: DocumentNode = gql`
  mutation CreateServiceAreaOffice(
    $id: UUID!
    $name: String!
    $shorthandName: String!
    $address: AddressInput!
    $comment: String
    $confidentialComment: String
    $legacyID: Int
  ) {
    createServiceAreaOffice(
      id: $id
      name: $name
      shorthandName: $shorthandName
      address: $address
      comment: $comment
      confidentialComment: $confidentialComment
      legacyID: $legacyID
    )
  }
`;

export const UPDATE_SERVICE_AREA_OFFICE: DocumentNode = gql`
  mutation UpdateServiceAreaOffice($id: UUID!, $name: String, $shorthandName: String, $comment: String, $confidentialComment: String, $legacyID: Int) {
    updateServiceAreaOffice(
      id: $id
      name: $name
      shorthandName: $shorthandName
      comment: $comment
      confidentialComment: $confidentialComment
      legacyID: $legacyID
    )
  }
`;

export const DELETE_SERVICE_AREA_OFFICE: DocumentNode = gql`
  mutation DeleteServiceAreaOffice($id: UUID!) {
    deleteServiceAreaOffice(id: $id)
  }
`;

export const UPDATE_ADDRESSES: DocumentNode = gql`
  mutation UpdateAddresses($addresses: [UpdateAddressInput!]!) {
    updateAddresses(addresses: $addresses)
  }
`;

export const VERIFY_SUBSTITUTE: DocumentNode = gql`
  mutation VerifySubstitute($id: UUID!) {
    verifySubsitute(userID: $id)
  }
`;

export const UPDATE_SPECIALIZATION_OPERATOR: DocumentNode = gql`
  mutation UpdateSpecialization($id: UUID!, $verified: Boolean, $certificate: UploadInput) {
    updateSubstituteSpecializations(id: $id, verified: $verified, certificate: $certificate)
  }
`;

export const SEND_MESSAGE: DocumentNode = gql`
  mutation SendMessage($userID: UUID!, $subject: String!, $content: String!, $serviceID: UUID) {
    sendMessage(userID: $userID, subject: $subject, content: $content, serviceID: $serviceID)
  }
`;

export const PUBLISH_SERVICE: DocumentNode = gql`
  mutation PublishService($serviceID: String!) {
    publishService(serviceID: $serviceID)
  }
`;

export const UPDATE_SERVICE: DocumentNode = gql`
  mutation UpdateService(
    $serviceID: UUID!
    $comment: String
    $memo: String
    $establishmentDoctorID: UUID
    $regularFeeRange: ServiceFeeRangeUpdateInput
    $holidayFeeRange: ServiceFeeRangeUpdateInput
    $start: DateTime
    $end: DateTime
    $establishmentID: UUID
    $kind: String
    $partnerConfirmedContract: Boolean
    $substituteConfirmedContract: Boolean
    $substituteConfirmedServiceInfo: Boolean
    $stateInsuredPatientCount: Int
    $privatePatientCount: Int
    $necropsyCount: Int
    $consultationViaTelephoneCount: Int
    $confirmCounts: Boolean
    $instantAssign: Boolean
    $priority: Boolean
    $allinclusive: Boolean
    $kvShareRateMobile: String
    $kvShareRateOffice: String
    $discount: Float
    $break: ServiceBreakInput
    $parentServiceId: UUID
  ) {
    updateService(
      serviceID: $serviceID
      comment: $comment
      memo: $memo
      establishmentDoctorID: $establishmentDoctorID
      regularFeeRange: $regularFeeRange
      holidayFeeRange: $holidayFeeRange
      start: $start
      end: $end
      establishmentID: $establishmentID
      kind: $kind
      partnerConfirmedContract: $partnerConfirmedContract
      substituteConfirmedContract: $substituteConfirmedContract
      substituteConfirmedServiceInfo: $substituteConfirmedServiceInfo
      stateInsuredPatientCount: $stateInsuredPatientCount
      privatePatientCount: $privatePatientCount
      necropsyCount: $necropsyCount
      consultationViaTelephoneCount: $consultationViaTelephoneCount
      confirmCounts: $confirmCounts
      instantAssign: $instantAssign
      priority: $priority
      allinclusive: $allinclusive
      kvShareRateMobile: $kvShareRateMobile
      kvShareRateOffice: $kvShareRateOffice
      discount: $discount
      break: $break
      parentServiceId: $parentServiceId
    )
  }
`;

export const DELETE_SERVICE: DocumentNode = gql`
  mutation DeleteService($serviceID: UUID!) {
    deleteService(serviceID: $serviceID)
  }
`;

export const CANCEL_SERVICE: DocumentNode = gql`
  mutation CancelService($serviceID: UUID!, $cancellationReason: String!) {
    cancelService(serviceID: $serviceID, cancellationReason: $cancellationReason)
  }
`;

export const UPDATE_PARTNER_LOGISTICS_PREFERENCES_OPERATOR: DocumentNode = gql`
  mutation UpdatePartnerLogisticsPreferences(
    $id: UUID!
    $requiresDoctorsBagDelivery: Boolean
    $requiresFolderDelivery: Boolean
    $requiresCardReader: Boolean
    $cardReaderSerialNumbers: [String!]
  ) {
    updatePartnerLogisticsPreferences(
      id: $id
      requiresDoctorsBagDelivery: $requiresDoctorsBagDelivery
      requiresFolderDelivery: $requiresFolderDelivery
      requiresCardReader: $requiresCardReader
      cardReaderSerialNumbers: $cardReaderSerialNumbers
    )
  }
`;

export const UPDATE_SERVICE_LOGISTICS: DocumentNode = gql`
  mutation UpdateServiceLogistics(
    $id: UUID!
    $logisticsStatus: logistics_status_type
    $partnerRequiresFolderDelivery: Boolean
    $partnerRequiresDoctorsBagDelivery: Boolean
    $partnerRequiresCardReader: Boolean
    $cardReaderSerialNumbers: [String!]
    $substituteHasDoctorsBag: Boolean
  ) {
    updateServiceLogistics(
      id: $id
      logisticsStatus: $logisticsStatus
      partnerRequiresFolderDelivery: $partnerRequiresFolderDelivery
      partnerRequiresDoctorsBagDelivery: $partnerRequiresDoctorsBagDelivery
      partnerRequiresCardReader: $partnerRequiresCardReader
      cardReaderSerialNumbers: $cardReaderSerialNumbers
      substituteHasDoctorsBag: $substituteHasDoctorsBag
    )
  }
`;

export const UPDATE_SUBSTITUTE_OPERATOR: DocumentNode = gql`
  mutation UpdateSubstitute(
    $substituteID: UUID!
    $memo: String
    $license: UploadInput
    $trainingConfirmed: Boolean
    $liabilityInsurance: DocumentLiabilityInsuranceInput
    $taxNumber: String
    $verified: Boolean
    $has_doctors_bag: Boolean
    $specialization: String
  ) {
    updateSubstitute(
      substituteID: $substituteID
      memo: $memo
      license: $license
      trainingConfirmed: $trainingConfirmed
      liabilityInsurance: $liabilityInsurance
      taxNumber: $taxNumber
      verified: $verified
      has_doctors_bag: $has_doctors_bag
      specialization: $specialization
    )
  }
`;

export const UPDATE_INSTITUTIONS_OPERATOR: DocumentNode = gql`
  mutation UpdateInstitutions($institutions: [InstitutionUpdateInput!]!) {
    updateInstitutions(institutions: $institutions)
  }
`;

export const SUBMIT_OFFICESERVICE_OPERATOR: DocumentNode = gql`
  mutation SubmitOfficeService($services: [OfficeServiceInput!]!, $totalCount: Float, $userID: UUID, $publish: Boolean!) {
    submitOfficeServices(userID: $userID, services: $services, totalCount: $totalCount, publish: $publish)
  }
`;

export const SUBMIT_MOBILESERVICE_OPERATOR: DocumentNode = gql`
  mutation SubmitMobileService($services: [MobileServiceInput!]!, $totalCount: Float, $userID: UUID, $publish: Boolean!) {
    submitMobileServices(userID: $userID, services: $services, totalCount: $totalCount, publish: $publish)
  }
`;

export const UPDATE_ESTABLISHMENTS_OPERATOR: DocumentNode = gql`
  mutation UpdateEstablishments($establishments: [EstablishmentUpdateInput!]!) {
    updateEstablishments(establishments: $establishments)
  }
`;

export const UPDATE_SERVICE_SUBMISSION_OPERATOR: DocumentNode = gql`
  mutation UpdateServiceSubmission($submissionID: UUID!, $serviceID: UUID, $content: String) {
    updateServiceSubmissions(submissionID: $submissionID, serviceID: $serviceID, content: $content)
  }
`;

export const UPDATE_CUSTOMER_PROFILE_OPERATOR: DocumentNode = gql`
  mutation UpdateCustomerProfile(
    $userID: UUID!
    $memo: String
    $title: String
    $gender: user_gender
    $firstName: String
    $lastName: String
    $birthDate: Date
    $mobile1: String
    $mobile2: String
    $fax: String
    $phone: String
    $legacy: UpdateLegacyUserInput
    $contactEmail: String
    $serviceFeeValue: Float
    $serviceFeeFrequency: String
    $serviceFeeFirstChargeDate: Date
    $suspendedContractFee: Int
    $activeContract: Boolean
    $invoicingEmail: String
  ) {
    updateCustomerProfile(
      userID: $userID
      memo: $memo
      title: $title
      gender: $gender
      firstName: $firstName
      lastName: $lastName
      birthDate: $birthDate
      mobile1: $mobile1
      mobile2: $mobile2
      fax: $fax
      phone: $phone
      legacy: $legacy
      contactEmail: $contactEmail
      serviceFeeValue: $serviceFeeValue
      serviceFeeFrequency: $serviceFeeFrequency
      serviceFeeFirstChargeDate: $serviceFeeFirstChargeDate
      suspendedContractFee: $suspendedContractFee
      activeContract: $activeContract
      invoicingEmail: $invoicingEmail
    )
  }
`;

export const UPDATE_BANKACCOUNTS_OPERATOR: DocumentNode = gql`
  mutation UpdateBankaccounts($accounts: [BankAccountUpdateInput!]!) {
    updateBankAccounts(accounts: $accounts)
  }
`;

export const UPDATE_ADDRESSES_OPERATOR: DocumentNode = gql`
  mutation UpdateAddresses($addresses: [UpdateAddressInput!]!) {
    updateAddresses(addresses: $addresses)
  }
`;

export const ADD_ESTABLISHMENT_DOCTOR_OPERATOR: DocumentNode = gql`
  mutation AddEstablishmentDoctor($establishmentID: UUID!, $name: String!, $kvSeats: Float!, $lanr: String!) {
    addEstablishmentDoctor(establishmentID: $establishmentID, name: $name, kvSeats: $kvSeats, lanr: $lanr)
  }
`;

export const UPDATE_ESTABLISHMENT_DOCTOR_OPERATOR: DocumentNode = gql`
  mutation UpdateEstablishmentDoctor($establishmentDoctorID: UUID!, $name: String, $kvSeats: Float, $lanr: String) {
    updateEstablishmentDoctor(establishmentDoctorID: $establishmentDoctorID, name: $name, kvSeats: $kvSeats, lanr: $lanr)
  }
`;

export const DELETE_ESTABLISHMENT_DOCTOR_OPERATOR: DocumentNode = gql`
  mutation DeleteEstablishmentDoctor($establishmentDoctorID: UUID!) {
    deleteEstablishmentDoctorOperator(establishmentDoctorID: $establishmentDoctorID)
  }
`;

export const EXPORT_BOOKINGS_OPERATOR: DocumentNode = gql`
  mutation ExportBookings($dryRun: Boolean!) {
    exportBookings(dryRun: $dryRun) {
      id
      count
      bookedOn
      exportedOn
      count
      product {
        id
        productNumber
        price
      }
      paymentMethod {
        ... on debtor_bill_payment_method {
          id
          debtor {
            debtorNumber
          }
          bankAccount {
            accountHolder
          }
        }
        ... on debtor_sepa_payment_method {
          id
          debtor {
            debtorNumber
          }
          bankAccount {
            accountHolder
          }
        }
      }
    }
  }
`;

export const DELETE_SERVICE_SUBMISSION_OPERATOR: DocumentNode = gql`
  mutation DeleteServiceSubmissions($submissionID: UUID!) {
    deleteServiceSubmissions(submissionID: $submissionID)
  }
`;

export const ADD_APPLICANT_TO_SERVICE_OPERATOR: DocumentNode = gql`
  mutation Apply($serviceID: UUID!, $substituteID: UUID, $chainCandidate: Boolean!, $offer: Float) {
    apply(serviceID: $serviceID, substituteID: $substituteID, chainCandidate: $chainCandidate, offer: $offer)
  }
`;

export const ADD_SPECIALIZATION_TO_SUBSTITUTE: DocumentNode = gql`
  mutation AddSpecializationToSubstitute($substituteID: UUID, $specializations: [SubstituteSpecializationInput!]!) {
    addSubstituteSpecializations(substituteID: $substituteID, specializations: $specializations)
  }
`;

export const REVOKE_APPLICATION_OPERATOR: DocumentNode = gql`
  mutation RevokeApplication($serviceID: UUID!, $substituteID: UUID!) {
    revokeApplication(serviceID: $serviceID, substituteID: $substituteID)
  }
`;

export const SEND_SERVICE_NEWSLETTER_BY_STATE_OPERATOR: DocumentNode = gql`
  mutation SendServiceNewsletter($subject: String!, $content: String!, $state: String!) {
    sendServiceNewsletterEmail(subject: $subject, content: $content, state: $state)
  }
`;

export const SEND_SERVICE_NEWSLETTER_OPERATOR: DocumentNode = gql`
  mutation SendServiceNewsletterByState($subject: String!, $content: String!, $state: String!, $substituteID: UUID) {
    sendServiceNewsletterEmailByState(subject: $subject, content: $content, state: $state, substituteID: $substituteID)
  }
`;

export const SEND_USERS_MASS_EMAIL_OPERATOR: DocumentNode = gql`
  mutation SendUsersMassEmail(
    $subject: String!
    $content: String!
    $targetGroup: String!
    $roles: [String!]!
    $state: String
    $userID: UUID
    $attachments: [UploadInput]
  ) {
    sendUsersMassEmail(
      subject: $subject
      content: $content
      targetGroup: $targetGroup
      roles: $roles
      state: $state
      userID: $userID
      attachments: $attachments
    )
  }
`;

export const SEND_ORDER_CONFIMRATION_OPERATOR: DocumentNode = gql`
  mutation SendOrderConfirmation(
    $customerId: String!
    $email: String!
    $fax: String!
    $assignments: [OrderConfirmationAssignmentInput!]!
    $currentDateTime: String!
  ) {
    sendOrderConfirmation(customerId: $customerId, email: $email, fax: $fax, assignments: $assignments, currentDateTime: $currentDateTime)
  }
`;

export const SEND_ORDER_SUMMARY_OPERATOR: DocumentNode = gql`
  mutation SendOrderSummary(
    $substituteId: String!
    $email: String!
    $name: String!
    $id: String!
    $from: String!
    $to: String!
    $assignments: [OrderConfirmationAssignmentInput!]!
  ) {
    sendOrderSummary(substituteId: $substituteId, email: $email, name: $name, id: $id, from: $from, to: $to, assignments: $assignments)
  }
`;

export const SEND_DOCUMENTS_OPERATOR: DocumentNode = gql`
  mutation SendDocuments($email: String!, $serviceId: String!, $notice: UploadInput, $contract: UploadInput) {
    sendDocuments(email: $email, serviceId: $serviceId, notice: $notice, contract: $contract)
  }
`;

export const UPDATE_DOCUMENT_LIABILITY_INSURANCE: DocumentNode = gql`
  mutation UpdateDocumentLiabilityInsurance($id: UUID!, $validFrom: Date, $validTo: Date, $insuranceName: String, $insuranceNumber: String) {
    updateDocumentLiabilityInsurance(id: $id, validFrom: $validFrom, validTo: $validTo, insuranceName: $insuranceName, insuranceNumber: $insuranceNumber)
  }
`;

export const DELETE_INSURANCE_DOCUMENT: DocumentNode = gql`
  mutation DeleteInsuranceDocument($documentID: UUID!) {
    deleteInsuranceDocument(documentID: $documentID)
  }
`;

export const DELETE_LICENSE_DOCUMENT: DocumentNode = gql`
  mutation DeleteLicenseDocument($substituteID: UUID!) {
    deleteLicenseDocument(substituteID: $substituteID)
  }
`;

export const DELETE_SPECIALIZATION_DOCUMENT: DocumentNode = gql`
  mutation DeleteSpecializationDocument($specializationID: UUID!) {
    deleteSpecializationDocument(specializationID: $specializationID)
  }
`;

export const DELETE_DOCUMENT: DocumentNode = gql`
  mutation DeleteDocument($documentID: UUID!) {
    deleteDocument(documentID: $id)
  }
`;

export const UPDATE_SUBSTITUTE_BLACKLIST: DocumentNode = gql`
  mutation updateSubstituteServiceNewsletterBlacklist($substituteID: UUID!, $states: [String!]!) {
    updateSubstituteServiceNewsletterBlacklist(substituteID: $substituteID, states: $states)
  }
`;

export const DELETE_ESTABLISHMENT_OPERATOR: DocumentNode = gql`
  mutation DeleteEstablishment($establishmentID: UUID!) {
    deleteEstablishmentOperator(establishmentID: $establishmentID)
  }
`;

export const DEACTIVATE_USER: DocumentNode = gql`
  mutation DeactivateUser($userID: UUID!, $reason: String!) {
    deactivateUser(userID: $userID, reason: $reason)
  }
`;

export const CREATE_SUBSTITUTE_OPERATOR: DocumentNode = gql`
  mutation CreateSubstituteOperator(
    $email: String!
    $title: String!
    $gender: user_gender
    $firstName: String!
    $lastName: String!
    $birthDate: Date!
    $mobile1: String
    $mobile2: String
    $phone: String
    $fax: String
    $trainingConfirmed: Boolean!
    $taxNumber: String!
    $address: AddressInput!
    $bankAccount: BankAccountInput!
    $specialization: SubstituteSpecializationInput!
  ) {
    createSubstituteOperator(
      email: $email
      title: $title
      gender: $gender
      firstName: $firstName
      lastName: $lastName
      birthDate: $birthDate
      mobile1: $mobile1
      mobile2: $mobile2
      phone: $phone
      fax: $fax
      trainingConfirmed: $trainingConfirmed
      taxNumber: $taxNumber
      address: $address
      bankAccount: $bankAccount
      specialization: $specialization
    )
  }
`;

export const CREATE_PARTNER_OPERATOR: DocumentNode = gql`
  mutation CreatePartnerOperator(
    $email: String!
    $title: String!
    $gender: user_gender
    $firstName: String!
    $lastName: String!
    $birthDate: Date!
    $mobile1: String
    $mobile2: String
    $phone: String
    $fax: String
    $institution: InstitutionInput!
    $establishment: EstablishmentInput!
    $establishmentDoctor: EstablishmentDoctorInput
  ) {
    createPartnerOperator(
      email: $email
      title: $title
      gender: $gender
      firstName: $firstName
      lastName: $lastName
      birthDate: $birthDate
      mobile1: $mobile1
      mobile2: $mobile2
      phone: $phone
      fax: $fax
      institution: $institution
      establishment: $establishment
      establishmentDoctor: $establishmentDoctor
    )
  }
`;

export const DELETE_DEBTOR_BILL_PAYMENT_METHOD: DocumentNode = gql`
  mutation DeleteDebtorBillPaymentMethod($debtorBillPaymentMethodID: UUID!) {
    deleteDebtorBillPaymentMethod(debtorBillPaymentMethodID: $debtorBillPaymentMethodID)
  }
`;

export const DELETE_DEBTOR_SEPA_PAYMENT_METHOD: DocumentNode = gql`
  mutation DeleteDebtorSepaPaymentMethod($debtorSepaPaymentMethodID: UUID!) {
    deleteDebtorSepaPaymentMethod(debtorSepaPaymentMethodID: $debtorSepaPaymentMethodID)
  }
`;

export const KAFKA_PRODUCE_ALL_SERVICES: DocumentNode = gql`
  mutation KafkaProduceAllServices {
    kafkaProduceAllServices
  }
`;

export const UPDATE_LEGACY_INFORMATION: DocumentNode = gql`
  mutation UpdateLegacyInformation($userID: UUID!, $bonusFee: Int, $bagHandlingFee: Int) {
    updateLegacyInformation(userID: $userID, bonusFee: $bonusFee, bagHandlingFee: $bagHandlingFee)
  }
`;
